/* eslint-disable no-undef */
/* eslint-disable max-len */
<template lang="pug">
  div#mapa
    l-map(style='width: 90%' :zoom='zoom' :center='center')
      l-tile-layer(:url='url' :attribution='attribution')
      l-marker(
        v-for="(country, index) in countries"
        :key="index"
        :lat-lng='latlng(country.location.lat, country.location.lng)'
        ref="pin"
        @click="mostrarData(country)"
      )
        l-popup
          b  {{country.countryregion}}
          br
          small Confirmados: {{ country.confirmed}}
          br
          small Muertes: {{ country.deaths}}
          br
          small Recuperados: {{ country.recovered}}
</template>

<script>
import {
  LMap, LTileLayer, LMarker, LPopup,
} from 'vue2-leaflet'

export default {
  name: 'Mapa',
  props: {
    countries: {
      type: Array,
      default() {
        return []
      },
    },
  },
  components: {
    LMap, LTileLayer, LMarker, LPopup,
  },
  data() {
    return {
      zoom: 3,
      // eslint-disable-next-line no-undef
      center: L.latLng(0, 0),
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      // url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      // eslint-disable-next-line no-undef
      marker: L.latLng(0, 0),
    }
  },
  methods: {
    latlng(lat, lng) {
      // eslint-disable-next-line no-undef
      return L.latLng(lat, lng)
    },
    mostrarData(pais) {
      this.$emit('countrySel', pais)
    },
  },
  // mounted () {
  //   this.$nextTick(() => {
  //     this.$refs.marker.mapObject.openPopup()
  //   })
  // },
}
</script>

<style lang="css" scoped>
  #mapa {
    height: 700px;
    width: 100%;
    margin: 0;
  }
</style>
